// extracted by mini-css-extract-plugin
export default {"body":"NoOrdersScreen_body__GBjqu"};